import Contract from "slotworks/utils/contract";
import HarleySpineSymbolBehaviour from "./spine-symbol-behaviour";

export default class HarleyAnticipateSpineSymbolBehaviour extends HarleySpineSymbolBehaviour {

    public anticipate(): Contract<void> {
        return this.animate("antic", false, true);
    }

    public highlight(): Contract<void> {
        return Contract.empty();
    }

    public win(): Contract<void> {
        return Contract.empty();
    }

    public cycle(): Contract<void> {
        return Contract.empty();
    }

    public updateTransform(): void {
        if(this.spine) {
            this.symbol.setVisible(false);
        }
        super.updateTransform();
    }

}